// @systeme: contrat
// L'abonnement d'un foyer : l'essai, les plans, le paiement chez Stripe, la résiliation
// en trois clics, la renonciation à la rétractation. Quand l'essai finit sans
// abonnement, l'app passe en mode allégé : sans assistant, mais tout le reste marche
// et rien n'est perdu (DEC-007).
import { z } from 'zod';
import { SchemaClePlan, SchemaDroitPlan, SchemaStatutAbonnement, SchemaTypeQuota, } from '../enumerations.js';
import { SchemaInstant, SchemaJour } from './elements.js';
export const SchemaPlanPublic = z.object({
    cle: SchemaClePlan,
    nom: z.string(),
    description: z.string(),
    /** Le prix mensuel TTC en euros, tel que réglé par l'admin. 0 tant que rien n'est facturé. */
    prixTtc: z.number().min(0),
    droits: z.record(SchemaDroitPlan, z.boolean()),
    quotas: z.record(SchemaTypeQuota, z.number().int().min(0)),
    actif: z.boolean(),
});
export const SchemaEtatAbonnement = z.object({
    statut: SchemaStatutAbonnement,
    planCle: SchemaClePlan,
    /** Le prix payé, figé à la souscription ; nul à l'essai. */
    prixTtc: z.number().nullable(),
    essaiFinLe: SchemaJour.nullable(),
    periodeFinLe: SchemaInstant.nullable(),
    resiliationDemandeeLe: SchemaInstant.nullable(),
    /** Un nouveau tarif annoncé, et la date à partir de laquelle il s'applique. */
    prixAVenir: z.object({ prixTtc: z.number(), le: SchemaInstant }).nullable(),
    /** Vrai quand l'assistant se repose : essai fini, impayé, ou résilié et période écoulée. */
    modeAllege: z.boolean(),
    /** Faux tant que Stripe n'est pas configuré : l'écran le dit sans proposer de payer. */
    paiementConfigure: z.boolean(),
    plans: z.array(SchemaPlanPublic),
});
export const SchemaDemandePaiement = z.object({
    planCle: z.enum(['essentiel', 'complet']),
    /** Obligatoire : la renonciation expresse au droit de rétractation de 14 jours (code de la consommation). */
    renonciationRetractation: z.literal(true, {
        error: 'Pour commencer tout de suite, il faut renoncer au délai de rétractation.',
    }),
});
/** L'adresse où envoyer l'utilisatrice (page de paiement ou portail Stripe). */
export const SchemaLienExterne = z.object({ url: z.url() });
//# sourceMappingURL=abonnement.js.map